export default {"src":"/_next/static/media/externalLink_24.d2f3ac48.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};